import React, { Fragment } from "react";
import { connect } from "react-redux";
import { ApplicationState, ConnectedReduxProps } from "@reducers/index";
import { UserRole } from "@models/user-roles";
import {
  deleteRequest,
  fetchRequest,
  createRequest,
  updateRequest
} from "@actions/user-role";
import UserRoleForm from "@components/user-roles/Form";
import userRoleApi from "@api/user-role";
import { injectIntl } from "react-intl";

interface PropsFromState {
  loading: boolean;
  data: UserRole[];
  errors?: string;
  count: number;
}

interface PropsFromDispatch {
  fetchRequest: typeof fetchRequest;
  deleteRequest: typeof deleteRequest;
}

// Combine both state + dispatch props - as well as any props we want to pass - in a union type.
type AllProps = PropsFromState & PropsFromDispatch & ConnectedReduxProps;

class UserRoleFormPage extends React.Component<AllProps> {
  state = {
    userRole: null,
    userRole_id: this.props.match.params.id,
    is_fetched: false
  };

  componentDidMount() {
    if (this.state.userRole_id) {
      this.fetchItem();
    }
  }

  fetchItem = () => {
    userRoleApi
      .getItem({
        params: {
          id: this.state.userRole_id
        }
      })
      .then(({ data }) => {
        this.setState({
          userRole: data
        });
      })
      .catch(error => console.log(error));
  };

  getContent = () => {
    if (this.state.userRole_id && !this.state.userRole) {
      return null;
    }

    return (
      <UserRoleForm
        userRole={this.state.userRole}
        intl={this.props.intl}
        listUrl={"/users/roles"}
        history={this.props.history}
        updateRequest={this.props.updateRequest}
        createRequest={this.props.createRequest}
      />
    );
  };

  render() {
    return <Fragment>{this.getContent()}</Fragment>;
  }
}

const mapStateToProps = ({ userRoles }: ApplicationState) => ({
  loading: userRoles.loading,
  errors: userRoles.errors
});

const mapDispatchToProps = {
  createRequest,
  updateRequest
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(UserRoleFormPage));
